import { Base } from "@src/core/models/base";

export interface Transaction extends Base {
  assetId: string;
  block: string;
  blockIndex: string;
  gasFees: number;
  network: string;
  offerId: string;
  orderId: string;
  status: TransactionStatus;
  timestamp: string;
  transactionHash: string;
  ttl: string;
}

export enum TransactionStatus {
  AwatingConfirmation = "awaiting_confirmation",
  Failed = "failed",
  Finished = "finished",
}
